import { Injectable, resource, signal } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { DriftsMeddelelseHistorik } from './driftsmeddelelse-historik.model';

@Injectable({
  providedIn: 'root',
})
export class DriftsMeddelelserHistorikDatasource extends RestDatasource<DriftsMeddelelseHistorik> {
  override endpoint = '/api/admin/driftsmeddelelsehistorik';

  driftsMeddelelseId = signal<number | undefined>(undefined);
  data = resource({
    params: () => this.driftsMeddelelseId(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify({
            meddelelseId: params,
          }),
          sortBy: 'tidspunkt',
          descending: true,
        },
        abortSignal
      );
    },
  });
}
